var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"filter-item"}},[_c(_vm.getComponent,{tag:"component",attrs:{"filter":_vm.filter,"value":_vm.value},on:{"setFilterValue":_vm.setFilterValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }